var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.1622,
    height: 3.45946,
    rx: 1,
    fill: "#747272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1.2973,
    width: 3.89189,
    height: 16.4324,
    rx: 1,
    fill: "#747272"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2703,
    width: 17.7297,
    height: 3.45946,
    rx: 1,
    fill: "#747272"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1081,
    y: 1.72973,
    width: 3.89189,
    height: 16,
    rx: 1,
    fill: "#747272"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 29.8378,
    width: 3.89189,
    height: 18.1622,
    rx: 1,
    fill: "#747272"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.72973,
    y: 44.1081,
    width: 16.4324,
    height: 3.89189,
    rx: 1,
    fill: "#747272"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2703,
    y: 44.1081,
    width: 17.7297,
    height: 3.89189,
    rx: 1,
    fill: "#747272"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1081,
    y: 29.8378,
    width: 3.89189,
    height: 16.8649,
    rx: 1,
    fill: "#747272"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.69ed93684fb421e8799769764547456d.svg";
export { ForwardRef as ReactComponent };